import { render, staticRenderFns } from "./PermissionsTexts.vue?vue&type=template&id=ad4c205e"
var script = {}
import style0 from "./PermissionsTexts.vue?vue&type=style&index=0&id=ad4c205e&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports